const yup = require("yup");
module.exports = yup.string().required("First name is required");
